import { z } from 'zod'

export type BulkUpdateSupplierEmissionsFormData = {
  partnershipId: string
  installationId: string
  supplierEmissionsReportId: string
}

const schema = z
  .object({
    partnershipId: z.string(),
    installationId: z.string(),
    supplierEmissionsReportId: z.string()
  })
  .refine(
    data =>
      data.partnershipId !== '' ||
      data.installationId !== '' ||
      data.supplierEmissionsReportId !== '',
    { message: 'At least one field must be selected for update' }
  )

export const getInitialFormData = (): BulkUpdateSupplierEmissionsFormData => ({
  partnershipId: '',
  installationId: '',
  supplierEmissionsReportId: ''
})

export const validateBulkUpdateSupplierEmissionsForm = (
  data: BulkUpdateSupplierEmissionsFormData
) => schema.safeParse(data)

export const EMPTY_VALUE = '__EMPTY__'
